import React, { FC } from 'react';
import { Typography } from '@galaxy-ds/core';
import EmailIcon from './email.svg?react';
import PhoneIcon from './phone.svg?react';
import EllipseIcon from './ellipse.svg?react';
import {
  LawyerConnectionPermissions,
  LawyerConnectionUser,
} from '@law-connect/types';
import style from './style.module.less';
import { useTranslation } from 'react-i18next';

interface Props {
  user: LawyerConnectionUser;
  contactInfoPending: boolean;
  onRequestContact?: () => void;
  permissions: LawyerConnectionPermissions;
}

export const ContactInfo: FC<Props> = ({
  user,
  onRequestContact,
  contactInfoPending,
  permissions,
}) => {
  const { t } = useTranslation();

  return (
    <div className={style.contactInfo}>
      <Typography variant='body2' className={style.contactInfoText}>
        <div className={style.contactLabelContainer}>
          <EmailIcon
            className={`${style.icon} ${user.email ? '' : style.unknown}`}
          />
          <a
            href={`mailto:${user.email}`}
            onClick={(e) => e.stopPropagation()}
            className={style.contactLink}
          >
            {(permissions?.userDetails && user.email) ||
              t('connect.email-not-provided')}
          </a>
        </div>
        <EllipseIcon className={style.separator} />
        <div className={style.contactLabelContainer}>
          <PhoneIcon
            className={`${style.icon} ${user.phone ? '' : style.unknown}`}
          />
          {user.phone ? ( //permissions?.phoneNumber &&
            <a
              href={`tel:${user.phone}`}
              onClick={(e) => e.stopPropagation()}
              className={style.contactLink}
            >
              {user.phone}
            </a>
          ) : (
            <span className={style.noPhoneNumber}>
              {t('lawyer.none-entered')}{' '}
            </span>
          )}
          {contactInfoPending ? (
            <div className={style.contactInfoPending}>
              {t('lawyer.request-contact-info.pending')}
            </div>
          ) : !user.phone ? (
            <span
              className={style.requestLink}
              onClick={(e) => {
                e.stopPropagation();
                onRequestContact?.();
              }}
            >
              {t('lawyer.request')}
            </span>
          ) : null}
        </div>
      </Typography>
    </div>
  );
};
